window.TableFilterSearch = {
    searchBox: null,
    searchInput: null,
    clearButton: null,

    init: function () {
        this.searchBox = document.getElementById("input-tablesearch-box");
        this.searchInput = this.searchBox.querySelector("input");
        this.clearButton = this.searchBox.querySelector(".clear-cross");
        this.addEvents();
    },

    addEvents: function () {
        this.searchInput.addEventListener("input", () => {
            if (TableFilterSearch.searchInput.value) {
                // this.showAddressSearchResults();
                this.showCloseButton();
            } else {
                // this.hideAddressSearchResults();
                this.hideCloseButton();
            }
        });

        this.clearButton?.addEventListener("click", () => {
            this.clearSearchBox();
        });
    },

    clearSearchBox: function () {
        this.searchBox.querySelector("input").value = "";
        // this.hideAddressSearchResults();
        this.hideCloseButton();
    },

    hideCloseButton: function () {
        this.clearButton.classList.add("d-none");
    },

    showCloseButton: function () {
        this.clearButton.classList.remove("d-none");
    },
};
